import { Component } from "@angular/core";
@Component({
  selector: "service-export",
  templateUrl: "./service-export.component.html",
})
export class ServiceExportComponent {
}
